// Module
var code = `<div class="grid-container">
    <div id="tiles-grid" class="tiles-grid"></div>
</div>
`;
// Exports
export default code;